import { useAtom } from 'jotai'
import { atomWithStorage } from 'jotai/utils'

const TAG_AUTO_COMPLETE_STORAGE_KEY = 'generator::tag-complete'
export const tagCompleteAtom = atomWithStorage<boolean | undefined>(
  TAG_AUTO_COMPLETE_STORAGE_KEY,
  true,
)

/**
 * IMPORTANT: do NOT pin this hook to `getDefaultStore()` like the
 * legacy code did. The whole app tree is now wrapped in
 * `<JotaiProvider store={requestContext.jotaiStore}>` from `RootShell`,
 * so every other `useAtom` in the same component tree resolves to that
 * request-scoped store. If we pin this one read/write to `defaultStore`,
 * the atom keeps separate state in two stores: the setter writes into
 * `defaultStore` while the rest of the UI re-renders against
 * `requestContext.jotaiStore`. The visible symptom is the home page's
 * Autocomplete switch becoming "stuck" — clicking it fires
 * `setEnableCompletion(false)` into `defaultStore`, but `<UISwitch
 * isSelected={enableCompletion}>` is reading from
 * `requestContext.jotaiStore` and never sees the change.
 *
 * Use the provider store (i.e. omit the `store` option) so reads and
 * writes always land on the same store instance.
 */
export const useTagComplete = () => useAtom(tagCompleteAtom)

export function hasUsedTagComplete(): boolean {
  return window.localStorage?.getItem(TAG_AUTO_COMPLETE_STORAGE_KEY) === 'true'
    ? true
    : false
}
